export const FEATURE_DEPOSIT_PROMO = 'kb-shared.feature.depositpromo';
export const MESSAGING = 'kb-shared.feature.messaging';
export const FEATURE_INITIATE_MESSAGES = 'kb-shared.feature.initiatemessages';

/**
 * The key used on your feature flag will be the key you supply in the url.
 * Where as the `flagKey` is what we use in code to identify the feature.
 * ie. If your object is :
 * CONFIG = {
 *     'COOL-THING' : {flagKey: 'SOMETHING.FEATURE' }
 * }
 * then the url should be `?ff.COOL-THING=true`
 * In your JS/React, you would check if the feature exists using the flagKey though.
 */
const CONFIG = {
  'DEPOSIT-PROMO': {
    flagKey: FEATURE_DEPOSIT_PROMO,
    value: undefined, // set to the code of the discount, or undefined to turn off
    description: 'Enables special deposit promo for cycle payments'
  },
  MESSAGING: {
    flagKey: MESSAGING,
    value: true,
    description: 'Enables messaging'
  },
  INITIATE_MESSAGES: {
    flagKey: FEATURE_INITIATE_MESSAGES,
    value: true,
    description: 'Enables patients initiating new messages'
  }
};

export default CONFIG;
